module.exports = __webpack_public_path__ + "img/icono-teamworkup.13bb38ae.svg";